import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from '../ui/Button';
const tiers = [{
  name: 'Drop-In',
  price: '35',
  period: 'per class',
  description: 'Perfect for visiting fighters or those with unpredictable schedules.',
  features: ['Access to any scheduled class', 'Use of heavy bags during open mat', 'No commitment required'],
  highlighted: false
}, {
  name: 'Unlimited',
  price: '185',
  period: 'per month',
  description: 'Our core membership for dedicated students who want to train consistently.',
  features: ['Unlimited Muay Thai classes', 'Unlimited Strength & Conditioning', 'Access to all open mat sessions', 'Sparring approval track', 'No initiation fee'],
  highlighted: true
}, {
  name: 'Fight Team',
  price: '250',
  period: 'per month',
  description: 'For active competitors requiring specialized attention and fight prep.',
  features: ['Everything in Unlimited', 'Invitation to Fight Team sparring', '2x monthly private pad sessions', 'Fight camp programming', 'Cornering at local/regional bouts'],
  highlighted: false
}];
export function Pricing() {
  return <section id="memberships" className="py-24 bg-zinc-950 relative" data-id="element-130">
      <div className="container mx-auto px-6" data-id="element-131">
        <div className="text-center mb-16 md:mb-24" data-id="element-132">
          <h2 className="font-display text-5xl md:text-7xl text-white uppercase mb-4" data-id="element-133">
            Commit to the <span className="text-red-600" data-id="element-134">Grind</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto" data-id="element-135">
            Simple, transparent pricing. No hidden fees, no BS contracts. Pick
            your path and get on the mats.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-136">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative flex flex-col p-8 ${tier.highlighted ? 'bg-zinc-900 border-2 border-red-600 transform md:-translate-y-4' : 'bg-zinc-900/50 border border-zinc-800'}`} data-id="element-137">
              {tier.highlighted && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-red-600 text-white px-4 py-1 font-display tracking-widest uppercase text-sm" data-id="element-138">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-139">
                <h3 className="font-display text-3xl text-white uppercase tracking-wide mb-2" data-id="element-140">
                  {tier.name}
                </h3>
                <p className="text-zinc-400 text-sm h-10" data-id="element-141">{tier.description}</p>
              </div>

              <div className="mb-8 flex items-end gap-2" data-id="element-142">
                <span className="font-display text-6xl text-white leading-none" data-id="element-143">
                  ${tier.price}
                </span>
                <span className="text-zinc-500 mb-2" data-id="element-144">{tier.period}</span>
              </div>

              <ul className="space-y-4 mb-8 flex-grow" data-id="element-145">
                {tier.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3 text-zinc-300" data-id="element-146">
                    <Check size={20} className="text-red-600 shrink-0 mt-0.5" data-id="element-147" />
                    <span className="text-sm" data-id="element-148">{feature}</span>
                  </li>)}
              </ul>

              <Button variant={tier.highlighted ? 'primary' : 'outline'} className="w-full mt-auto" onClick={() => alert(`Sign up flow for ${tier.name} would open here.`)} data-id="element-149">
                Join Now
              </Button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}